import React from "react";
import BottomSheet from "../../../components/ui/BottomSheet";
import SheetHeader from "../../../components/ui/SheetHeader";
import Button from "../../../components/ui/Button";
import PaymentsCurrencyInput from "./PaymentsCurrencyInput";
import { useIsDesktopViewport } from "../../../hooks/useIsDesktopViewport";
import { ISaleForm } from "../../../classes/interfaces";
import { Body, Footer } from "./MoneyPaymentModal.styles";

interface MoneyPaymentModalProps {
  isOpen: boolean;
  /**
   * Fecha esta folha (X do cabecalho e toque no fundo). Ficava ligado ao
   * closeModalAddress, entao o X fechava o modal de endereco e a tela de troco
   * continuava aberta.
   */
  onRequestClose: () => void;
  /** Handler do botao "Cancelar". */
  onCancel: () => void;
  formValues: ISaleForm;
  setFormValues: React.Dispatch<React.SetStateAction<ISaleForm>>;
  onSemTroco: () => void;
  onConfirm: () => void;
}

export default function MoneyPaymentModal({
  isOpen,
  onRequestClose,
  onCancel,
  formValues,
  setFormValues,
  onSemTroco,
  onConfirm,
}: MoneyPaymentModalProps) {
  const desktop = useIsDesktopViewport();

  return (
    <BottomSheet open={isOpen} onClose={onRequestClose} centered={desktop} maxHeight="60%">
      <SheetHeader
        title="Forma de Pagamento - Dinheiro"
        sub="Coloque o valor do dinheiro a ser utilizado"
        onClose={onRequestClose}
      />
      <Body>
        <PaymentsCurrencyInput
          label="Troco para"
          name="changeFor"
          value={formValues.changeFor}
          onChange={setFormValues}
        />
      </Body>
      <Footer>
        <Button variant="ghost" full onClick={onCancel}>
          Cancelar
        </Button>
        <Button variant="soft" full onClick={onSemTroco}>
          Sem troco
        </Button>
        <Button variant="primary" full onClick={onConfirm}>
          Salvar
        </Button>
      </Footer>
    </BottomSheet>
  );
}
